import { ChartIcon, DocumentIcon, TableIcon } from "@/components/icons";

import { ChartLazy } from "./ChartLazy.tsx";
import { compactCard } from "./CompactCard.tsx";
import { DataTable } from "./DataTable.tsx";
import { Document } from "./Document.tsx";
import { Download } from "./Download.tsx";
import { KeyValues } from "./KeyValues.tsx";
import { registerUiComponent } from "./registry.tsx";

/**
 * Componentes que el backend puede pedir por nombre (seccion 9).
 *
 * El nombre tiene que coincidir con el campo `render` de la herramienta en el
 * catalogo. Si no coincide, el registro muestra un aviso visible: es un error
 * de programacion y debe verse, no fallar en silencio.
 *
 * El tercer argumento es la versión COMPACTA, la que se dibuja en la ventana
 * pequeña de Work. Solo la llevan los tres que de verdad no caben en 380px;
 * una lista de pares y un enlace de descarga caben igual de bien en los dos
 * sitios, y darles una versión aparte sería inventar un problema.
 */
export const registerChatComponents = (): void => {
  registerUiComponent("data_table", DataTable, compactCard("Tabla", TableIcon));
  registerUiComponent("chart", ChartLazy, compactCard("Gráfico", ChartIcon));
  registerUiComponent("key_values", KeyValues);
  registerUiComponent("download", Download);
  registerUiComponent(
    "document",
    Document,
    compactCard("Documento", DocumentIcon),
  );
};
